import { createLoadableComponent, createModuleLoader } from '@mews/framework';
import { TextKey } from '@mews-distributor/common';

import { showSpaceCategoriesPreviousTab } from '../../actions/navigation';
import { createViewLoadingError } from '../../components/common/createViewLoadingError';

import { moduleId } from './constants';

const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "spaceCategories" */ './module'),
    dependencies: [],
});

export const SpaceCategories = createLoadableComponent({
    loader,
    component: 'RoomsView',
    ...createViewLoadingError({
        loadingStatusTextKey: TextKey.LoadingAvailability,
        dismissAction: showSpaceCategoriesPreviousTab,
    }),
});
